'use strict';

var React = require('react');

var SvgChannelsMajor = function SvgChannelsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 3.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.25v1.5h-.25a2.75 2.75 0 0 0-2.75 2.75v2a2.75 2.75 0 0 0 2.75 2.75h2a2.75 2.75 0 0 0 2.75-2.75v-.25h1.5v.25a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.25h-1.5v-.25c0-.487-.127-.944-.348-1.34l2.909-2.91h1.939a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.94l-2.91 2.908a2.738 2.738 0 0 0-1.34-.348h-.25v-1.5h.25a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Zm.5 1.5v1h1v-1h-1Zm-.5 5.5c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25h-2Zm7.75-4.5v-1h1v1h-1Zm0 6.25v1h1v-1h-1Z"
  }));
};
SvgChannelsMajor.displayName = "ChannelsMajor";

exports.SvgChannelsMajor = SvgChannelsMajor;
